import { render, staticRenderFns } from "./StatisticsAccessByRegion.vue?vue&type=template&id=49db6ef2&"
import script from "./StatisticsAccessByRegion.vue?vue&type=script&lang=js&"
export * from "./StatisticsAccessByRegion.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsAccessByRegion.vue?vue&type=style&index=0&id=49db6ef2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports